import LotsModal from '@/views/Fdc/Detection/Components/LotsModal'
import FeatureSelection from '@/views/Fdc/Analysis/MultivariateAnalysis/Tabs/FeatureSelection'
import PCA from '@/views/Fdc/Analysis/MultivariateAnalysis/Tabs/PCA'
import HotelingT2 from '@/views/Fdc/Analysis/MultivariateAnalysis/Tabs/HotelingT2'
import _ from 'lodash'
import Dayjs from 'dayjs'

/**
 * Analysis > Multivariate Analysis
 * Multivariate Analysis
 */
export default {
  name: 'MultivariateAnalysis',
  components: {
    'lots-modal': LotsModal, // Select Lot Modal component
    'feature-selection': FeatureSelection, // Feature Selection Tab component
    'pca': PCA, // PCA Tab component
    'hoteling-t2': HotelingT2 // Hoteling T2 component
  },
  mounted () {
  },
  watch: {
    /**
     * fromDate 변화 감지
     */
    fromDate () {
      this.toMinDate = this.fromDate
    },
    /**
     * toDate 변화 감지
     */
    toDate () {
      this.fromMaxDate = this.toDate
    }
  },
  computed: {
  },
  methods: {
    /**
     * 스플릿 패널 리사이즈 시 플라틀리 리사이즈
     * 윈도우 리사이즈 이벤트 생성해서 디스패치
     */
    splitPanesResized () {
      window.dispatchEvent(new Event('resize'))
    },
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    /**
     * 검색 Validation
     * @returns {Boolean} validation 성공 여부
     */
    _searchValid () {
      if (this.selectedTreeNode.length === 0 || this.selectedTreeNode.detail.fab === '' || this.selectedTreeNode.detail.eqpId === '' || this.selectedTreeNode.detail.moduleId === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Equipment']))
        return false
      }
      return true
    },
    /**
     * MVA Analysis 조회
     */
    async searchData () {
      if (!this._searchValid()) {
        return
      }
      this.summaryData.fab = this.selectedTreeNode.detail.fab
      this.summaryData.eqpId = this.selectedTreeNode.detail.eqpId
      this.summaryData.moduleId = this.selectedTreeNode.detail.moduleId
      this.summaryData.fromDate = Dayjs(this.fromDate).format('YYYYMMDD') + '000000000'
      this.summaryData.toDate = Dayjs(this.toDate).format('YYYYMMDD') + '235959999'

      this.selectedTab(0)
      this.isFeatureSelectionDataExists = false
      this.isPcaDataExists = false
      this.isHotelingT2DataExists = false

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )

      setTimeout(() => this.runFeatureSelection(), 50)
    },
    initChart () {
      this.$refs.featureSelection.briqueChart.purge('featureChart')
      this.$refs.pca.briqueChart.purge('screePlot')
      this.$refs.pca.briqueChart.purge('loadingChart')
      this.$refs.pca.briqueChart.purge('scoreChart')
      this.$refs.hotelingT2.briqueChart.purge('hotelingT2')
    },
    runFeatureSelection () {
      this.$refs.featureSelection.searchFeatureImportance()
      this.isFeatureSelectionDataExists = true
    },
    runPCA () {
      this.$refs.pca.searchTraningModel()
      this.isPcaDataExists = true
    },
    runHotelingT2 () {
      this.$refs.hotelingT2.searchHotelingT2()
      this.isHotelingT2DataExists = true
    },
    /**
     * Select Lot Modal 닫기
     * @param {*} value
     */
    resetModalData (value) {
      this.selectLotsModal.visible = value
    },
    /**
     * Select Lot Modal apply callback
     * @param {*} list
     */
    applyLots (list) {
      this.selectedLots = list
    },
    /**
     * selectLots Modal 열기
     */
    showLotsModal () {
      this.selectLotsModal.visible = true
    },
    /**
     * Tab 선택 시 event
     * @param {Number} idx tab index
     */
    selectedTab (idx) {
      this.step = idx
    },
    /**
     * Tab 변경 시 event
     */
    onTabsChanged (idx) {
      switch (idx) {
        case 0:
          if (!this.isFeatureSelectionDataExists) setTimeout(() => this.runFeatureSelection(), 50)
          break
        case 1:
          if (!this.isPcaDataExists) setTimeout(() => this.runPCA(), 50)
          break
        case 2:
          if (!this.isHotelingT2DataExists) setTimeout(() => this.runHotelingT2(), 50)
          break
        default:
          break
      }
      this.selectedImportanceData = []
      this.selectedImportanceData = this.$refs.featureSelection.$refs.featureGrid.gridApi.getSelectedRows().map(c => c.variable)
      // 기존 process 주석처리
      // this.$refs.featureSelection.rowData.filter(d => d._status.checked).forEach(row => {
      //   const item = _.clone(row)
      //   delete item['_status']
      //   this.selectedImportanceData.push(item.variable)
      // })
      this.summaryData.selectedVariables = this.selectedImportanceData
      this.splitPanesResized()
    },
    /**
     * Data 초기화
     */
    resetData () {
      let tmpSummary = _.clone(this.summaryData)
      tmpSummary.featureImportance = null
      tmpSummary.trainingModel = null
      tmpSummary.hotelingT2 = null
      this.summaryData = tmpSummary

      // chart 초기화
      this.$refs.featureSelection.briqueChart.purge('featureChart')
      this.$refs.pca.briqueChart.purge('screePlot')
      this.$refs.pca.briqueChart.purge('loadingChart')
      this.$refs.pca.briqueChart.purge('scoreChart')
      this.$refs.hotelingT2.briqueChart.purge('hotelingT2')
    }
  },
  data () {
    const dateString = new Date().toDateString()
    let fromDt = new Date(Dayjs(dateString).add(-1, 'day').format('YYYY.MM.DD'))
    let toDt = new Date()
    return {
      isFeatureSelectionDataExists: false,
      isPcaDataExists: false,
      isHotelingT2DataExists: false,
      step: 0, // tab index
      selectLotsModal: {
        visible: false
      }, // Select Lot Modal 표시 여부
      selectedTreeNode: [], // 선택된 EQP Tree node
      fromDate: fromDt, // From Date (condition)
      toDate: toDt, // To Date (condition)
      fromMaxDate: toDt, // From Date Max value
      fromMinDate: null, // From Date Min value
      toMaxDate: toDt, // To Date Max value
      toMinDate: fromDt, // To Date Min value
      summaryData: {} // Multivariate Anlalysis 관련 Object (Summary 결과)
    }
  }
}
